var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99997 16.7732C12.4182 16.7732 16 13.1914 16 8.77316C16 4.35491 12.4182 0.773193 7.99997 0.773193C3.58172 0.773193 0 4.35491 0 8.77316C0 13.1914 3.58172 16.7732 7.99997 16.7732Z",
    fill: "#FF8C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 4.77319V12.7732H2.66683V4.77319H13.3335ZM8.00016 9.43381L12.4875 5.25448H3.51281L8.00016 9.43381ZM9.41065 8.77325L12.8594 11.9852V5.56117L9.41065 8.77325ZM9.05996 9.0998L8.00016 10.0869L6.94025 9.0998L3.51281 12.2919H12.4875L9.05996 9.0998ZM6.58967 8.77325L3.1409 5.56117V11.9853L6.58967 8.77325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "res/media/mail.68502bb46142a845c8d8c3f9d1b445f2.svg";
export { ForwardRef as ReactComponent };